import { CategoryFilterOption } from '@immosky/types';

export interface CategoryFilterOptions {
  allOptions: CategoryFilterOption[];
  rentOptions: CategoryFilterOption[];
  buyOptions: CategoryFilterOption[];
}

export const CATEGORY_ALL_OPTION: CategoryFilterOption = {
  text: 'filters.category.main.all',
  value: 'all',
};

export const CATEGORY_HOUSE_OPTION: CategoryFilterOption = {
  text: 'filters.category.main.house',
  value: 'house',
};

export const CATEGORY_FLAT_OPTION: CategoryFilterOption = {
  text: 'filters.category.main.apartment',
  value: 'flat',
};

export const CATEGORY_ESTATE_OPTION: CategoryFilterOption = {
  text: 'filters.category.main.estate',
  value: 'land',
};

export const CATEGORY_INCOME_OPTION: CategoryFilterOption = {
  text: 'filters.category.main.incomeProperty',
  value: 'income',
};

export const CATEGORY_COMMERCIAL_OPTION: CategoryFilterOption = {
  text: 'filters.category.main.commercial',
  value: 'commercial',
};

export const CATEGORY_DEFAULT_OPTION = CATEGORY_ALL_OPTION;

export const categoryFilterOptions: CategoryFilterOptions = {
  allOptions: [
    CATEGORY_ALL_OPTION,
    CATEGORY_HOUSE_OPTION,
    CATEGORY_FLAT_OPTION,
    CATEGORY_ESTATE_OPTION,
    CATEGORY_INCOME_OPTION,
    CATEGORY_COMMERCIAL_OPTION,
  ],
  rentOptions: [
    CATEGORY_ALL_OPTION,
    CATEGORY_HOUSE_OPTION,
    CATEGORY_FLAT_OPTION,
    CATEGORY_COMMERCIAL_OPTION,
  ],
  buyOptions: [
    CATEGORY_ALL_OPTION,
    CATEGORY_HOUSE_OPTION,
    CATEGORY_FLAT_OPTION,
    CATEGORY_ESTATE_OPTION,
    CATEGORY_INCOME_OPTION,
    CATEGORY_COMMERCIAL_OPTION,
  ],
};
